module.exports = __webpack_public_path__ + "qa-technologies.zgT6pzRh.svg";